import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { ProjectFindInterface } from '@zaoblako/shared/modules/project/dto/project/project-find.dto';
import type { ProjectTemplateAllQueryInterface } from '@zaoblako/shared/modules/project/dto/template/project.template.all.query.dto';
import type { ProjectTemplateFindInterface } from '@zaoblako/shared/modules/project/dto/template/project-template-find.dto';
import type { ProjectTemplateItemsPageInterface } from '@zaoblako/shared/modules/project/dto/template/project-template-items-page.dto';
import type { ProjectTemplateListQueryInterface } from '@zaoblako/shared/modules/project/dto/template/project-template-list-query.dto';
import type { ProjectTemplateRegistryQueryInterface } from '@zaoblako/shared/modules/project/dto/template/project-template-registry-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectTemplateService extends BaseService {
  protected baseUrl = '/project-template';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(`${this.baseUrl}/`);
  }

  public findPage(queryParams: ProjectTemplateRegistryQueryInterface): Observable<ProjectTemplateItemsPageInterface> {
    return this.http.get<ProjectTemplateItemsPageInterface>(`${this.baseUrl}/items`, {
      params: this.objectToHttpParams(queryParams as Record<string, unknown>)
    });
  }

  public findFlat(queryParams: ProjectTemplateListQueryInterface): Observable<ProjectTemplateFindInterface[]> {
    return this.http.get<ProjectTemplateFindInterface[]>(`${this.baseUrl}/flat`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public findTree(queryParams: ProjectTemplateListQueryInterface): Observable<ProjectTemplateFindInterface[]> {
    return this.http.get<ProjectTemplateFindInterface[]>(`${this.baseUrl}/tree`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public findAll(queryParams?: ProjectTemplateAllQueryInterface): Observable<ProjectTemplateFindInterface[]> {
    return this.http.get<ProjectTemplateFindInterface[]>(`${this.baseUrl}/all`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public clone(templateId: number): Observable<ProjectTemplateFindInterface> {
    return this.http.get<ProjectTemplateFindInterface>(`${this.baseUrl}/${templateId}/clone`);
  }

  public getCreatedProjectsWidget(templateId: number): Observable<ProjectFindInterface[]> {
    return this.http.get<ProjectFindInterface[]>(`${this.baseUrl}/${templateId}/created-projects`);
  }
}
